import {call, put, takeLatest} from 'redux-saga/effects';
import ApiUtil from "src/utils/ApiUtil";
import {
    CURRENT_COUNTRY_CODE_QUERY_START,
    CurrentCountryCodeQueryStartAction,
    getCurrentCountryCodeQueryFailedAction,
    getCurrentCountryCodeQuerySuccessAction
} from "src/actions/CurrentCountryCodeQueryAction";


export function* getCurrentCountryCode(action: CurrentCountryCodeQueryStartAction) {
    try {
        // @ts-ignore
        const response = yield call(ApiUtil.callApiWithTimeout, "getcurrentcountry", {});
        yield put(getCurrentCountryCodeQuerySuccessAction(response));
    } catch (error) {
        yield put(getCurrentCountryCodeQueryFailedAction());
        return;
    }
}

export default function* currentCountryCode() {
    yield takeLatest(CURRENT_COUNTRY_CODE_QUERY_START, getCurrentCountryCode);
}